import createHeader from "./create-header.mjs";
export const NH1 = createHeader('1');
export const NH2 = createHeader('2');
export const NH3 = createHeader('3');
export const NH4 = createHeader('4');
export const NH5 = createHeader('5');
export const NH6 = createHeader('6');